import { getWdsSurfaceNeutralProps, wdsThemeColors } from './wds-theme-colors';
export const getManualFixSurfaceProps = wizardPresentation => {
  if (wizardPresentation.softIssueListSurfaces) {
    return getWdsSurfaceNeutralProps();
  }
  return {
    backgroundColor: 'B60'
  };
};

/**
 * Maps wizard presentation flags to RuleElement chrome (borders, edit icon, width).
 * Studio / Studio 2 use dark resting borders and secondary-hover active borders;
 * OD uses standard borders and primary-active focus borders.
 */
export const getRuleElementPropsFromPresentation = wizardPresentation => {
  const usesStudioElementChrome = wizardPresentation.softIssueListSurfaces;
  return {
    hoveredBackgroundColor: usesStudioElementChrome ? wdsThemeColors.surfaceNeutral : 'B60',
    hoveredBorderColor: usesStudioElementChrome ? wdsThemeColors.borderStandardSecondaryHover : wdsThemeColors.borderFocus,
    iconButtonPriority: wizardPresentation.ruleIconButtonPriority,
    iconButtonSkin: wizardPresentation.ruleIconButtonSkin,
    notHoveredBorderColor: usesStudioElementChrome ? wdsThemeColors.borderStandardDark : wdsThemeColors.borderStandard,
    width: usesStudioElementChrome ? 'full' : 'normal'
  };
};
//# sourceMappingURL=get-rule-element-props-from-presentation.js.map